/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import gql from "graphql-tag";

export const UserQuery = gql`
  query UserQuery($userId: ID) {
    user: getUser(userId: $userId) {
      id
      created
      updated
      name
      email
      imageUrl
      address {
        line1
        line2
        city
        state
        zip
        country
        telephone1
        telephone2
      }
      organizations {
        id
        role
        status
        jobTitle
        disabled
        permissions
      }
    }
  }
`;

export const UpdateUserMutation = gql`
  mutation UpdateUser($user: UserInput!) {
    updateUser(user: $user) {
      id
      updated
      name
      email
      imageUrl
      address {
        line1
        line2
        city
        state
        zip
        country
        telephone1
        telephone2
      }
      organizations {
        role
        status
        jobTitle
      }
    }
  }
`;

export const UpdateUserPermissionMutation = gql`
  mutation UpdateUserPermission(
    $userId: ID!
    $permission: String!
    $add: Boolean!
  ) {
    status: updateUserPermission(
      userId: $userId
      permission: $permission
      add: $add
    )
  }
`;

export const UsersQuery = gql`
  query UsersQuery($orgId: ID) {
    users: getUsers(orgId: $orgId) {
      id
      created
      updated
      name
      email
      role
      status
      jobTitle
      imageUrl
      disabled
    }
  }
`;

export const InviteUserMutation = gql`
  mutation inviteUser($user: InviteUserInput!) {
    inviteUser(user: $user)
  }
`;

export const DisableUserMutation = gql`
  mutation disableUser($userId: ID!, $orgId: ID!) {
    disableUser(userId: $userId, orgId: $orgId)
  }
`;

export const EnableUserMutation = gql`
  mutation enableUser($userId: ID!, $orgId: ID!) {
    enableUser(userId: $userId, orgId: $orgId)
  }
`;

export interface UserData {
  user: User;
}

export interface UsersData {
  users: UserInfo[];
}

export interface User {
  id: string;
  created: string;
  updated: number;
  name: string;
  email: string;
  imageUrl: string;
  address: Address;
  discountCode: string;
  organizations: OrganizationInfo[];
  platform: boolean;
}

export interface UserInfo {
  id: string;
  created: number;
  updated: number;
  name: string;
  email: string;
  status: string;
  role?: string;
  jobTitle?: string;
  imageUrl: string;
  disabled: number;
}

export interface Address {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  telephone1: string;
  telephone2: string;
}

export interface OrganizationInfo {
  id: string;
  name: string;
  role: string;
  jobTitle: string;
  disabled: number;
  status: string;
  lastLogin: string;
  address: Address;
  permissions: string[];
}

export interface UserInput {
  id: string;
  name: string;
  imageUrl?: string;
  address: Address;
  organization?: OrganizationInfoInput;
}

export interface OrganizationInfoInput {
  id?: string;
  role?: string;
  jobTitle?: string;
}

export interface InviteUserInput {
  email: string;
  name: string;
  orgId: string;
  role: string;
}

export interface saveContactData {
  id: string;
  name: string;
  imageUrl: string;
  addressLine1: string;
  addressLine2: string;
  addressCity: string;
  addressCountry: string;
  addressZip: string;
  addressState: string;
  addressTelephone1: string;
  addressTelephone2: string;
  jobTitle: string;
  role: string;
}

export const ChangeEmailMutation = gql`
  mutation ($userId: ID!, $newEmail: String!) {
    status: changeEmail(userId: $userId, newEmail: $newEmail)
  }
`;

export const getS3PresignedUrl = gql`
  query ($uploadType: String!, $mimeType: String!) {
    getS3PresignedUrl(uploadType: $uploadType, mimeType: $mimeType) {
      uploadUrl
      downloadUrl
    }
  }
`;
